// src/components/SidebarMenu.tsx
import {VStack, Box, Spacer, Flex} from "@chakra-ui/react";
import React from "react";
import useUiStore from "../../store/useUiStore.ts";
import Logo from "../Logo.tsx";
import Icon from "../SmartIcon.tsx";
import Navigation from "../Navigation/Navigation.tsx";
import UserProfile from "../UserProfile/UserProfile.tsx";
import ToggleTheme from "../ToggleTheme/ToggleTheme.tsx";
import CreditsUsageWidget from "../Credits/CreditsUsageWidget.tsx";
import {useCreditsStore} from "../../store/useCreditsStore.ts";

const LeftSidebarMenu = () => {
  const {leftSidebarMenuState, toggleLeftSidebarMenuState} = useUiStore();
  const creditsBalance = useCreditsStore((state) => state.balance);
  const creditsStatus = useCreditsStore((state) => state.status);

  if (leftSidebarMenuState === "hidden") return null;

  return (
    <VStack
      h="100vh"
      align="start"
      justify="space-between"
      spacing={6}
      pt={10}
      pb={6}
      px={4}
      transition="all 0.3s ease-in-out"
      width={leftSidebarMenuState === "expanded" ? "20rem" : "6rem"}
      minW={leftSidebarMenuState === "expanded" ? "20rem" : "6rem"}
    >
      <Flex w="full" align="center" justify={leftSidebarMenuState === "expanded" ? 'space-between' : 'center'}>
        {leftSidebarMenuState === "expanded" && <Logo width={"100px"}/>}
        <Box
          as={"button"}
          className="group tap-highlight-color"
          onClick={toggleLeftSidebarMenuState}
        >
          <Icon
            className="fill-n-400 transition-colors group-hover:fill-n-300"
            name={leftSidebarMenuState === "minimized" ? "toggle-on" : "toggle-off"}
          />
        </Box>
      </Flex>
      <Box w="full">
        <Navigation minimizedState={leftSidebarMenuState === "minimized"}/>
      </Box>
      <Spacer/>
      <Box w="full">
        <Box mb={3}>
          <CreditsUsageWidget
            balance={creditsBalance}
            status={creditsStatus}
            minimized={leftSidebarMenuState === "minimized"}
            onUpgrade={() => useCreditsStore.getState().openPricing()}
            onManageBilling={() => useCreditsStore.getState().openPricing("billing")}
          />
        </Box>
        <UserProfile minimizedState={leftSidebarMenuState === "minimized"}/>
        {/*<ToggleTheme minimizedState={leftSidebarMenuState === "minimized"}/>*/}
      </Box>
    </VStack>
  );
};

export default LeftSidebarMenu;
